import React from "react";
import {useSite} from "../context/SiteContext";
import {APP_ANDROID, APP_IOS} from "../data/siteData";
import {asset} from "../utils";
import {StoreGlyph} from "./common/Icon";
import Bars from "./common/Bars";

// Booking is app-only: every "book" button on the site opens this download dialog.
const AppDialog = () => {
    const {appOpen, closeApp} = useSite();
    if (!appOpen) return null;

    return (
        <div className="pb-dialog-backdrop" onClick={closeApp}>
            <div className="pb-dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
                <button onClick={closeApp} aria-label="Close" className="pb-dialog-close">&times;</button>
                <img src={asset('assets/logo-black.png')} alt="Paddlers Box"
                     style={{height: 30, display: 'block', marginBottom: 18}}/>
                <h2 className="pb-dialog-title">Booking happens in the app</h2>
                <p className="pb-dialog-text">Live availability, payment and the QR scan that opens the box all live in
                    the Paddlers Box app — there is no booking on the website.</p>
                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                    <a href={APP_IOS} target="_blank" rel="noopener noreferrer"
                       className="pb-store-btn pb-store-ios hover-brighten">
                        <StoreGlyph kind="ios"/>Download on iOS
                    </a>
                    <a href={APP_ANDROID} target="_blank" rel="noopener noreferrer"
                       className="pb-store-btn pb-store-android hover-brighten">
                        <StoreGlyph kind="play"/>Get it on Google Play
                    </a>
                </div>
                <div style={{margin: '20px 0 0', display: 'flex', justifyContent: 'center'}}>
                    <Bars w={22} h={5} gap={5}/>
                </div>
                <p className="pb-dialog-foot">Free to download · Live availability · Scan to unlock, in the app</p>
            </div>
        </div>
    );
};

export default AppDialog;
